<template>
    <v-card outlined :color="(job.serviceColor || '#76a5af') + '25'">
        <v-card-title class="py-2">
            <v-row>
                <v-col class="mb-0 text-subtitle-1">
                   Job ID - {{this.job.jobId}} | {{this.job.customer}}
                </v-col>
                <v-col class="text-right" :cols="2">
                    <v-btn :to="{ name: 'edit', params: { jobId: this.job.jobId }}" pr fab depressed x-small>
                        <v-icon small>{{mdiChevronRight}}</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-subtitle class="pb-1 text-subtitle-2">
            <p class="mb-0">Due Date: {{this.jobDueDate || "N/A"}}</p>
        </v-card-subtitle>
        <v-card-text class="pb-1">
            <v-container class="pa-1">
                <v-row class="text-body-2 text-h6 mb-0">
                    <v-col class="pa-1">
                        <p class="mb-0">Address: {{this.job.address || "NA"}}</p>
                        <p class="mb-0">
                            {{this.job.contactName || "NA"}} | <a :href="'tel:' + this.job.contactPhoneNumber">{{this.job.contactPhoneNumber || "N/A"}}</a>
                        </p>
                        <p class="mb-0">{{this.job.service}}</p>
                    </v-col>
                    <v-col class="pa-1">
                        <p class="mb-0">{{this.job.borough}}</p>
                        <p class="mb-0">{{this.job.stage}}</p>
                        <p class="mb-0">{{this.job.jobSize}}</p>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-dialog v-model="editDialogIsOpen" persistent>
            <v-card>
                <edit-job @close="editDialogIsOpen = false" :job-id="job.jobId"></edit-job>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import { mdiChevronRight } from '@mdi/js'
    import EditJob from "./EditJob";
    export default {
        name: "JobDetail.vue",
        components: {
            EditJob
        },
        props: ["job"],
        data () {
            return {
                mdiChevronRight,
                editDialogIsOpen: false
            }
        },
        computed: {
            jobDueDate() {
                return this.job && this.job.dueDate ? new Date(this.job.dueDate).toLocaleDateString() : '';
            }
        }
    }
</script>

<style scoped>

</style>
